import styled from 'styled-components';
import Colors from '../../config/Colors';

export const AddButton = styled.button`
    min-width: 135px;
    height: 32px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: ${Colors.lightBlue};
    border: 1px solid ${Colors.lightBlue};
    border-radius: 4px;
    margin: 5px;

    &:hover {
        border: 1px solid ${Colors.blue_button};
        cursor: pointer;
    }
`;

export const Text = styled.span`
    font-size: 1.4rem;
    color: ${Colors.secondary};
    font-family: NunitoSans-Regular;
`;
